"use strict";

import angular from "angular";

import template from "./breadcrumb.component.html";
import "./breadcrumb.component.scss";

class BreadcrumbComponent {
    constructor() {}

    onSelectItem(item) {
        this.onSelect({ item });
    }
}

BreadcrumbComponent.$inject = [];

const name = "breadcrumbComponent";
const def = {
    controller: BreadcrumbComponent,
    bindings: {
        items: "<",
        onSelect: "&"
    },
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
